import { useCallback, useSyncExternalStore } from 'react';

export const useMatchMedia = (mediaQuery: string): boolean => {
	const subscribe = useCallback(
		(callback: () => void) => {
			const abortController = new AbortController();
			const mediaQueryList = window.matchMedia(mediaQuery);
			mediaQueryList.addEventListener('change', callback, {
				signal: abortController.signal,
			});
			return () => {
				abortController.abort();
			};
		},
		[mediaQuery],
	);
	return useSyncExternalStore(
		subscribe,
		() => window.matchMedia(mediaQuery).matches,
		() => false,
	);
};
